import { Colors } from '@honeyscience/honey-ui-toolkit';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';
import {
  HashRouter as Router,
  Switch,
  Route,
} from 'react-router-dom';
import Directory from 'mockStores/components/Directory';
import {
  SPBv4, SPBv5, LegacyPayPal, LegacyPayPalResult, Continue, NoFlows, VccStore, GuestPayPalButton,
} from 'mockStores/components/stores';
import MockVcc from 'mockStores/components/vcc/MockVcc';
import { ACCOUNT_LINKING_PAYPAL_SDK_URL, LINK_TO_PATH_MAP } from 'mockStores/lib/constants';
import { LinkNames } from 'mockStores/lib/types';
import { PaypalEnvs } from 'types';

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  link: {
    composes: 'label2',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '8px',
  },
  storeIcon: {
    marginRight: '4px',
  },
  title: {
    color: Colors.grey900,
    composes: 'title4',
    marginBottom: '8px',
  },
});

export const LINK_TO_COMPONENT_MAP = {
  [LinkNames.AccountLinkingNoShipping]: <SPBv5 paypalScript={ ACCOUNT_LINKING_PAYPAL_SDK_URL } noShipping={ true } />,
  [LinkNames.AccountLinking]: <SPBv5 paypalScript={ ACCOUNT_LINKING_PAYPAL_SDK_URL } />,
  [LinkNames.Continue]: <Continue />,
  [LinkNames.Directory]: <Directory />,
  [LinkNames.NoFlows]: <NoFlows />,
  [LinkNames.SPBv4]: <SPBv4 />,
  [LinkNames.SPBv5]: <SPBv5 paypalScript={ process.env.PAYPAL_SDK_URLS[PaypalEnvs.Sandbox] } />,
  [LinkNames.Vcc]: <VccStore />,
  [LinkNames.LegacyPayPal]: <LegacyPayPal />,
  [LinkNames.LegacyPayPalResult]: <LegacyPayPalResult />,
  [LinkNames.MockVcc]: <MockVcc />,
  [LinkNames.GuestPayPalButton]: <GuestPayPalButton />,
};

function Routes(): ReactElement {
  const classes = useStyles();

  function renderRoutes() {
    return Object.values(LinkNames).map((linkName) => {
      const { to, exact } = LINK_TO_PATH_MAP[linkName];
      return (
        <Route key={ linkName } path={ to } exact={ exact }>
          { LINK_TO_COMPONENT_MAP[linkName] }
        </Route>
      );
    });
  }

  return (
    <div className={ classes.container }>
      <Router hashType="noslash">
        <Switch>
          { renderRoutes() }
        </Switch>
      </Router>
    </div>
  );
}

export default Routes;
